(function () {
	const body = document.body;

	if (!body.classList.contains('main-site')) {
		return;
	}

	let ticking = false;

	function updateParallax() {
		const scrollY = window.scrollY;
		// Subtle downward drift: the hero moves at 30% of scroll speed
		const parallax = scrollY * 0.3;
		body.style.setProperty('--hero-parallax', parallax + 'px');
		ticking = false;
	}

	window.addEventListener(
		'scroll',
		function () {
			if (!ticking) {
				requestAnimationFrame(updateParallax);
				ticking = true;
			}
		},
		{ passive: true },
	);
})();
